import { render, staticRenderFns } from "./ActionPersonTemplate.vue?vue&type=template&id=0b378876"
import script from "./ActionPersonTemplate.vue?vue&type=script&lang=js"
export * from "./ActionPersonTemplate.vue?vue&type=script&lang=js"
import style0 from "./ActionPersonTemplate.vue?vue&type=style&index=0&id=0b378876&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports